import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Icon Block elements to display in the group */
  children: PropTypes.node.isRequired,
  /** Layout direction for the group */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
};
function IconBlockGroup(_ref) {
  var children = _ref.children,
    orientation = _ref.orientation;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-block-group",
    "data-orientation": orientation,
    "data-testid": "icon-block-group"
  }, children);
}
IconBlockGroup.propTypes = propTypes;

export { IconBlockGroup as default };
//# sourceMappingURL=IconBlockGroup.js.map
